import { DataItem } from 'vis-timeline';

export const compareCustomTimeItems = (a: DataItem, b: DataItem): boolean => a.id === b.id;
